import React from 'react';
import { Mail, ShieldCheck, ArrowRight } from 'lucide-react';
import logoWhite from '../assets/logo/fieldstech-logo-white.png';

const ComingSoon = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#060D1A] via-[#0A1E3D] to-[#050914] text-white flex flex-col justify-between relative overflow-hidden">
      {/* Luces de fondo ambientales */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-gradient-to-b from-cyan-500/15 via-blue-600/10 to-transparent rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute -bottom-1/3 -right-1/4 w-[700px] h-[700px] bg-gradient-to-l from-emerald-500/15 to-transparent rounded-full blur-3xl"></div>
      </div>

      {/* Cuadrícula decorativa tecnológica */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:48px_48px] pointer-events-none"></div>

      {/* 2. Identidad de marca: Logo en gran formato con resplandor cian */}
      <header className="relative z-10 max-w-7xl mx-auto w-full px-6 sm:px-8 pt-10 sm:pt-14 flex justify-center">
        <div className="group cursor-pointer">
          <img 
            src={logoWhite} 
            alt="Fieldstech" 
            className="h-16 sm:h-20 lg:h-24 w-auto object-contain drop-shadow-[0_0_24px_rgba(6,182,212,0.45)] transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      </header>

      {/* Contenido Principal */}
      <main className="relative z-10 max-w-3xl mx-auto px-6 sm:px-8 py-10 text-center flex-1 flex flex-col justify-center items-center">
        
        {/* 2. Badge superior */}
        <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-cyan-950/70 border border-cyan-500/30 text-cyan-300 text-xs sm:text-sm font-semibold mb-8 shadow-sm shadow-cyan-500/10 backdrop-blur-md">
          <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse"></span>
          <span>COMING SOON // PRÓXIMAMENTE</span>
        </div>

        {/* 3. Mensaje Institucional: Titular */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          Tu solución en la nube
        </h1>

        {/* 3. Mensaje Institucional: Subtítulo */}
        <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed mb-10 font-normal">
          Estamos construyendo la base para modernizar tu sistema antiguo a la nube
        </p>

        {/* 4. Caja de Contacto Directo */}
        <div className="w-full max-w-md mx-auto p-6 sm:p-8 rounded-2xl bg-white/[0.04] border border-white/10 backdrop-blur-xl shadow-2xl mb-10 text-center">
          <p className="text-sm sm:text-base font-medium text-gray-200 mb-5 leading-relaxed">
            ¿Tu empresa requiere un diagnóstico de arquitectura o migración?
          </p>
          
          <a
            href="mailto:customers@fieldstech.io?subject=Diagn%C3%B3stico%20de%20Arquitectura%20-%20Fieldstech"
            className="w-full inline-flex items-center justify-center gap-2.5 px-6 py-4 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white font-bold text-sm sm:text-base shadow-lg shadow-emerald-500/25 hover:shadow-emerald-500/40 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 group"
          >
            <Mail className="w-5 h-5 shrink-0" />
            <span>customers@fieldstech.io</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform shrink-0" />
          </a>
        </div>

        {/* 5. Sellos de Confianza y Cumplimiento */}
        <div className="inline-flex items-center justify-center gap-2 text-sm text-gray-300 px-4 py-2 rounded-lg bg-white/[0.03] border border-white/5">
          <ShieldCheck className="w-5 h-5 text-emerald-400 shrink-0" />
          <span className="font-medium">Especialistas Certificados en Google Cloud</span>
        </div>

      </main>

      {/* Footer minimalista */}
      <footer className="relative z-10 max-w-7xl mx-auto w-full px-6 sm:px-8 py-6 text-center text-xs text-gray-500 border-t border-white/5">
        <p>© {new Date().getFullYear()} Fieldstech. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
};

export default ComingSoon;
